import React, { useContext } from 'react';

import cx from 'classnames';

import EditableText from 'components/shared/EditableText';
import Icon from 'components/shared/Icon';
import CalendarSync from 'components/shared/Icon/icons/CalendarSync';
import UserSync from 'components/shared/Icon/icons/UserSync';
import LandingPageContext from 'components/shared/LandingPage/contexts/LandingPageContext';
import FormTitle from 'components/shared/Typography/FormTitle';
import Text from 'components/shared/Typography/Text';

import styles from './index.module.css';

function SyncBtn({ icon, text, onClick }) {
  return (
    <button type="button" className={styles.syncBtn} onClick={onClick}>
      {text && <Text>{text}</Text>}
      {icon && <Icon component={icon} />}
    </button>
  );
}

const BUTTONS = {
  syncContacts: <SyncBtn text="Sync to Contacts" icon={UserSync} onClick={() => null} />,
  syncCalendar: <SyncBtn text="Sync to Calendar" icon={CalendarSync} onClick={() => null} />,
};

const Subtitle = ({ data: blockData, onUpdate }) => {
  const {
    data: { text, placeholder, btnType },
  } = blockData;
  const { readOnly } = useContext(LandingPageContext);

  const handleChange = (newText) => {
    onUpdate({
      ...blockData,
      data: {
        ...blockData.data,
        text: newText,
      },
    });
  };

  if (readOnly && !text) return null;

  return (
    <FormTitle
      className={cx(styles.subtitle, 'custom-subtitle-block')}
      mainClassName={styles.mainTitle}
      button={BUTTONS[btnType]}
      noBorder
      withAction
    >
      <EditableText text={text} placeholder={placeholder} onChange={handleChange} isReadonly={readOnly} />
    </FormTitle>
  );
};

export default Subtitle;
